import Details from './RecommendationDetailsRoot';
import List from './Recommendations';
import Root from './RecommendationsRoot';
export { default as RecommendationCompanyBreadcrumb } from './RecommendationCompanyBreadcrumb';
export { default as RecommendationDetailsRoot } from './RecommendationDetailsRoot';
export { default as RecommendationList } from './RecommendationList';
export { default as useRecommendationsContext } from './RecommendationsContext';
export { RecommendationsProvider } from './RecommendationsContext';

export default {
  Root,
  List,
  Details,
};
